const headerHeroType = ({ hero }) => {
  if (!hero) {
    return null;
  }

  const firstHero = hero[0];

  if (!firstHero) {
    return null;
  }

  if (hero.length > 1) {
    return 'slider';
  }

  if (firstHero.url && firstHero.videoUrl) {
    return 'video_teaser';
  }

  if (firstHero.url && firstHero.imageUrl) {
    return 'teaser';
  }

  if (firstHero.imageUrl) {
    return 'image';
  }

  if (firstHero.videoUrl) {
    return 'video';
  }

  if (firstHero.readMoreText && firstHero.title) {
    return 'statement';
  }

  return null;
};

export default headerHeroType;
